export class VideoControls {
    constructor() {
        this.selectors = {
            container: '[js-video-controls]',
            video: 'video'
        };

        this.init();
    }

    init() {
        this.initVideoClasses();
        this.handleIntersectionAutoplay();

        document.body.addEventListener('click', this.handleEvent.bind(this));
    };

    handleEvent(e) {
        this.handlePausePlay(e);
    };

    handleIntersectionAutoplay() {
        let options = {
            root: null,
            rootMargin: '0px',
            threshold: 1.0,
        };

        const videoContainers = document.querySelectorAll(this.selectors.container);
        videoContainers.forEach(container => {
            const video = container.querySelector(this.selectors.video);

            let callback = function (entries) {
                entries.forEach(function (entry) {

                    if (!entry.isIntersecting) {
                        video.pause();
                        container.classList.remove('video-playing');

                    } else if (entry.isIntersecting) {
                        if (!container.classList.contains('video-manual-pause')) {
                            video.play();
                            container.classList.remove('video-paused');
                            container.classList.add('video-playing');
                        }
                    }
                });
            };

            if (video.getAttribute('autoplay') == 'autoplay' || video.getAttribute('autoplay') == true) {
                let observer = new IntersectionObserver(callback, options);
                if (container && video) observer.observe(container);
            }
        });


    }


    initVideoClasses() {
        const videoContainers = document.querySelectorAll(this.selectors.container);

        videoContainers.forEach(container => {
            const video = container.querySelector(this.selectors.video);

            if (video) {

                if (video.paused) {
                    container.classList.add('video-paused');
                    container.classList.remove('video-playing');

                } else {
                    container.classList.add('video-playing');
                    container.classList.remove('video-paused');
                }

            }
        })
    }

    handlePausePlay(e) {
        const target = e.target;

        if (target.closest(this.selectors.container)) {
            const container = target.closest(this.selectors.container);
            const video = container.querySelector(this.selectors.video);

            if (video) {

                if (video.paused) {
                    video.play();
                    container.classList.add('video-playing');
                    container.classList.remove('video-paused', 'video-manual-pause');

                } else {
                    video.pause();
                    container.classList.add('video-paused', 'video-manual-pause');
                    container.classList.remove('video-playing');
                }

            }
        }

    }
}